import React from 'react';

export const getColumns = type => {
  const columns = [
    {
      title: 'CNPJ',
      dataIndex: 'cnpj',
      key: 'cnpj',
      width: '20%',
    },
    {
      title: 'Razão Social',
      dataIndex: 'razao_social',
      key: 'razao_social',
    },
  ];

  if (type === 'matriz') {
    return columns;
  }

  return [
    ...columns,
    {
      title: 'Localização',
      dataIndex: 'cidade',
      key: 'cidade',
      render: (text, record) => (
        <span style={{ textTransform: 'capitalize' }}>
          {`${record.cidade} - ${record.uf}`}
        </span>
      ),
    },
  ];
};
